export const formatCurrency = (value) => {
  if (value === null || value === undefined) return "";

  const numericValue =
    typeof value === "string"
      ? parseFloat(value.replace(/[^0-9.]/g, ""))
      : value;

  if (isNaN(numericValue)) return value;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(numericValue);
};
